import '../../sass/template-parts/input.scss';

(() => {
    const $inputs = document.querySelectorAll('.input');

    if (!$inputs) return;

    $inputs.forEach($inputWrap => {
        const $input = $inputWrap.querySelector('.input__input input, .input__input textarea, .input__input select');
        const $togglePasswordVisibility = $inputWrap.querySelector('.input__toggle-password-visibility');

        const initTogglePasswordVisibility = () => {
            if (!$togglePasswordVisibility) return;

            $togglePasswordVisibility.addEventListener('click', () => {
                if ($input?.type === 'password') {
                    $input.type = 'text';
                    $togglePasswordVisibility.classList.add('input__toggle-password-visibility--visible');
                } else {
                    $input.type = 'password';
                    $togglePasswordVisibility.classList.remove('input__toggle-password-visibility--visible');
                }
            });
        };

        initTogglePasswordVisibility();
    });
})();
